// SP-2b — self-scoped staff UI flags (first-run tour dismissals and other
// one-time "seen it" stamps). Keys are lowercase-kebab (`^[a-z0-9-]{1,64}$`,
// server-validated); both endpoints return the caller's full stamped set.
// Hooks live in @/hooks/uiFlags/useUiFlags; query keys in uiFlagsKeys.

import { api } from "@/api/client";

export const uiFlagsApi = {
  list: () => api.get<string[]>(`/me/ui-flags`),
  stamp: (key: string) => api.post<string[]>(`/me/ui-flags/${key}`),
};
